/** Etiqueta accesible del spinner mientras se resuelve el cambio de día (FR-014). */
export const LOADING_LABEL = 'Cargando eventos del día seleccionado'

/** Título del estado vacío cuando el día elegido no tiene eventos (FR-017). */
export const EMPTY_STATE_TITLE = 'No hay eventos este día'
